var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "assistant-lp-chat-stores" }, [
      _c("span", {}, [
        _vm._v(_vm._s(_vm._f("trans")("st_public.Download Now")))
      ]),
      _c("div", { staticClass: "d-flex btn-options btn-group" }, [
        _c(
          "a",
          {
            staticClass: "btn",
            attrs: { target: "_blank", href: _vm.deeplink },
            on: {
              click: function($event) {
                return _vm.updateDeeplinkFrom("WORKS_DEEPLINK_1")
              }
            }
          },
          [
            _c("div", [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "17",
                    height: "20",
                    viewBox: "0 0 17 20",
                    fill: "none"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M14.2578 10.636C14.2349 8.10926 16.3461 6.88001 16.4427 6.82278C15.247 5.09573 13.3937 4.85975 12.7424 4.84094C11.1858 4.67866 9.67595 5.76366 8.88302 5.76366C8.07427 5.76366 6.85324 4.85662 5.53724 4.88327C3.84377 4.90914 2.25951 5.88047 1.39062 7.3888C-0.402556 10.4643 0.934808 14.9838 2.65281 17.4697C3.5122 18.6872 4.51641 20.0466 5.83083 19.9988C7.11675 19.9462 7.5971 19.1866 9.14891 19.1866C10.6865 19.1866 11.1375 19.9988 12.4781 19.9682C13.8582 19.9462 14.7271 18.7452 15.5564 17.5168C16.5495 16.1213 16.9484 14.747 16.9642 14.6765C16.9317 14.6655 14.2839 13.6644 14.2578 10.636Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M11.7255 3.2056C12.4171 2.34874 12.8904 1.18299 12.759 0C11.758 0.0439016 10.5061 0.685963 9.78515 1.52401C9.14733 2.2625 8.57757 3.47293 8.72476 4.61124C9.84925 4.69434 11.0038 4.04914 11.7255 3.2056Z",
                      fill: "white"
                    }
                  })
                ]
              )
            ]),
            _vm._v(
              "\n      " +
                _vm._s(_vm._f("trans")("st_public.iPhone")) +
                "\n    "
            )
          ]
        ),
        _c(
          "a",
          {
            staticClass: "btn",
            attrs: { target: "_blank", href: _vm.deeplink },
            on: {
              click: function($event) {
                return _vm.updateDeeplinkFrom("WORKS_DEEPLINK_2")
              }
            }
          },
          [
            _c("div", [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "18",
                    height: "20",
                    viewBox: "0 0 18 20",
                    fill: "none"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M1.52693 6.47852C1.18233 6.47852 0.889951 6.59869 0.64961 6.83903C0.409269 7.07937 0.289062 7.36777 0.289062 7.70438V12.8726C0.289062 13.2176 0.409233 13.5098 0.64961 13.7501C0.889951 13.9905 1.18233 14.1107 1.52693 14.1107C1.87128 14.1107 2.16188 13.9905 2.3985 13.7501C2.63465 13.5098 2.75304 13.2176 2.75304 12.8726V7.70438C2.75304 7.36773 2.63287 7.07937 2.3925 6.83903C2.15212 6.59869 1.86354 6.47852 1.52693 6.47852Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M11.4805 1.83878L12.3339 0.264526C12.3899 0.160304 12.37 0.0803828 12.2739 0.0241852C12.1696 -0.0242736 12.0895 0.000281275 12.0336 0.0961138L11.1683 1.68296C10.4068 1.34631 9.60152 1.17768 8.7523 1.17768C7.9029 1.17768 7.0975 1.34635 6.33638 1.68296L5.47103 0.0961138C5.41479 0.000281275 5.33469 -0.0240566 5.23069 0.0241852C5.13442 0.080636 5.11449 0.160304 5.17073 0.264526L6.02414 1.83878C5.15879 2.28008 4.46959 2.89468 3.9568 3.6839C3.44401 4.47356 3.1875 5.33649 3.1875 6.2742H14.305C14.305 5.33671 14.0485 4.47374 13.5357 3.6839C13.0229 2.89468 12.3377 2.28008 11.4805 1.83878ZM6.54663 4.12857C6.45434 4.22107 6.34412 4.26711 6.21599 4.26711C6.08761 4.26711 5.97963 4.22107 5.89153 4.12857C5.80344 4.0365 5.75939 3.9267 5.75939 3.79814C5.75939 3.67002 5.80344 3.56001 5.89153 3.46772C5.97963 3.37565 6.08786 3.32961 6.21599 3.32961C6.34412 3.32961 6.45434 3.37565 6.54663 3.46772C6.6387 3.56023 6.68495 3.67002 6.68495 3.79814C6.6847 3.92649 6.63848 4.0365 6.54663 4.12857ZM11.6126 4.12857C11.5243 4.22107 11.4161 4.26711 11.2882 4.26711C11.1598 4.26711 11.0496 4.22107 10.9575 4.12857C10.8652 4.0365 10.8192 3.9267 10.8192 3.79814C10.8192 3.67002 10.8652 3.56001 10.9575 3.46772C11.0496 3.37565 11.1598 3.32961 11.2882 3.32961C11.4163 3.32961 11.5243 3.37565 11.6126 3.46772C11.7008 3.56023 11.7447 3.67002 11.7447 3.79814C11.7447 3.92649 11.7007 4.0365 11.6126 4.12857Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M3.23438 14.7119C3.23438 15.0808 3.3625 15.3931 3.61879 15.6494C3.8753 15.9057 4.1876 16.0339 4.55629 16.0339H5.44576L5.45794 18.7625C5.45794 19.1071 5.57811 19.3997 5.81845 19.64C6.0588 19.8804 6.34741 20.0006 6.6838 20.0006C7.02819 20.0006 7.32075 19.8804 7.56112 19.64C7.8015 19.3997 7.92167 19.1071 7.92167 18.7625V16.0341H9.58026V18.7625C9.58026 19.1071 9.7004 19.3997 9.94077 19.64C10.1811 19.8804 10.4735 20.0006 10.8181 20.0006C11.1625 20.0006 11.455 19.8804 11.6954 19.64C11.9358 19.3997 12.0559 19.1071 12.0559 18.7625V16.0341H12.9574C13.3179 16.0341 13.6262 15.9059 13.883 15.6497C14.1392 15.3934 14.2674 15.0811 14.2674 14.7122V6.70703H3.23438V14.7119Z",
                      fill: "white"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M15.9759 6.47852C15.6393 6.47852 15.3509 6.59691 15.1105 6.83306C14.8702 7.06964 14.75 7.36025 14.75 7.70438V12.8726C14.75 13.2176 14.8701 13.5098 15.1105 13.7501C15.3509 13.9905 15.6395 14.1107 15.9759 14.1107C16.3203 14.1107 16.6128 13.9905 16.8532 13.7501C17.0936 13.5098 17.2137 13.2176 17.2137 12.8726V7.70438C17.2137 7.36021 17.0936 7.06964 16.8532 6.83306C16.6128 6.59691 16.3203 6.47852 15.9759 6.47852Z",
                      fill: "white"
                    }
                  })
                ]
              )
            ]),
            _vm._v(
              "\n      " +
                _vm._s(_vm._f("trans")("st_public.Android")) +
                "\n    "
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33fe5de5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33fe5de5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/assistant/Store.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-33fe5de5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/assistant/Store.vue
// module chunks = 10